// extracted by mini-css-extract-plugin
export default {"advancementDescription":"ExpandedRow__advancementDescription___FeEc6"};